import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IfNotTradeStoreDirective } from '../../multisite/trade/if-not-trade-store.directive';
import { IfTradeStoreDirective } from '../../multisite/trade/if-trade-store.directive';
import { LoginFormComponent } from '../form/login-form.component';
import { LoginFormRetailComponent } from '../form/retail/login-form-retail.component';
import { LoginFormTradeComponent } from '../form/trade/login-form-trade.component';
import { NLoginViewLayout } from '../view/layout/login-view-layout.interface';
@Component({
    selector: 'login-form-content',
    templateUrl: './login-form-content.component.html',
    styleUrls: ['./login-form-content.component.scss'],
    standalone: true,
    imports: [IfTradeStoreDirective, IfNotTradeStoreDirective, LoginFormRetailComponent, LoginFormTradeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormContentComponent extends LoginFormComponent {
    @Input()
    content: NLoginViewLayout.ILoginViewLayoutContent;
}
